import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import chatService from '../services'

export function useMutationPinMessage(roomId: string) {
	return useMutation({
		mutationFn: ({
			messageId,
			isPinned,
		}: {
			messageId: string
			isPinned: boolean
		}) => chatService.pinMessage(roomId, messageId, isPinned),
		onSuccess: (_, variables) => {
			// SSE chat:message_pinned handles cache invalidation
			toast.success(
				variables.isPinned ? 'ปักหมุดข้อความแล้ว' : 'ยกเลิกปักหมุดแล้ว',
			)
		},
		onError: () => {
			toast.error('ดำเนินการล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
